export const wordToUpperCase = (txt, word)=>{
    return txt.split(' ').map(v=>{
        if(v.toLowerCase() === word){
             return v.toUpperCase()   
        }else{
            return v
        }
    }).join(' ')
}